import { Navigate, Outlet } from "react-router-dom";
import { Flex, Spinner, Box, Heading, Text, Button, Icon } from "@chakra-ui/react";
import { Ban } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { colors } from "@/theme/colors";

export const RequireAuth = () => {
  const { session, loading, dataLoading, deactivated, signOut } = useAuth();

  if (loading || dataLoading) {
    return (
      <Flex minH="100vh" align="center" justify="center" bg={colors.page}>
        <Spinner size="xl" color={colors.teal} borderWidth="3px" />
      </Flex>
    );
  }

  if (!session) {
    return <Navigate to="/login" replace />;
  }

  if (deactivated) {
    return (
      <Flex minH="100vh" align="center" justify="center" bg={colors.page} p="6">
        <Box maxW="440px" textAlign="center" bg={colors.white} border="1px solid" borderColor={colors.border}
          borderRadius="16px" p="8" data-testid="deactivated-screen">
          <Flex align="center" justify="center" w="56px" h="56px" borderRadius="full" bg={colors.criticalBg} mx="auto" mb="4">
            <Icon as={Ban} boxSize="6" color={colors.poppy} />
          </Flex>
          <Heading fontFamily="heading" fontSize="xl" color={colors.textPrimary} mb="2">Account deactivated</Heading>
          <Text fontSize="sm" color={colors.textSecondary} mb="6">
            Your company's Hakina Safety account has been deactivated. Your data is safely retained.
            Please contact your administrator or Hakina Safety support to restore access.
          </Text>
          <Button onClick={signOut} data-testid="deactivated-signout">
            Sign out
          </Button>
        </Box>
      </Flex>
    );
  }

  return <Outlet />;
};
